function getNodeWidth(node) {
  var nodeStyles = window.getComputedStyle(node, null);
  var width = node.offsetWidth;

  var borderLeftWidth = nodeStyles.borderLeftWidth
    ? parseFloat(nodeStyles.borderLeftWidth)
    : 0;

  var borderRightWidth = nodeStyles.borderRightWidth
    ? parseFloat(nodeStyles.borderRightWidth)
    : 0;

  var paddingLeft = nodeStyles.paddingLeft
    ? parseFloat(nodeStyles.paddingLeft)
    : 0;

  var paddingRight = nodeStyles.paddingRight
    ? parseFloat(nodeStyles.paddingRight)
    : 0;

  return (
    width - borderRightWidth - borderLeftWidth - paddingLeft - paddingRight
  );
}

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=" .responsive-text-wrapper[data-v-2c2a226e] { display: inline-block; white-space: nowrap; -ms-transform-origin: left; -webkit-transform-origin: left; -o-transform-origin: left; -moz-transform-origin: left; transform-origin: left; } "; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();

var component = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"responsive-text-wrapper",style:(Object.assign({}, _vm.scaleStyle, _vm.transitionStyle))},[_vm._t("default")],2)},staticRenderFns: [],_scopeId: 'data-v-2c2a226e',
  name: "VueResponsiveText",
  props: {
    transition: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function data() {
    return {
      scale: 1,
      currentWidth: null,
      maxWidth: null
    };
  },
  computed: {
    scaleStyle: function scaleStyle() {
      var scaleValue = "scale(" + (this.scale) + ", " + (this.scale) + ")";

      return {
        msTransform: scaleValue,
        WebkitTransform: scaleValue,
        OTransform: scaleValue,
        MozTransform: scaleValue,
        transform: scaleValue
      };
    },
    transitionStyle: function transitionStyle() {
      if (this.transition) { return {
        msTransition: ((this.transition) + "ms"),
        WebkitTransition: ((this.transition) + "ms"),
        OTransition: ((this.transition) + "ms"),
        MozTransition: ((this.transition) + "ms"),
        transition: ((this.transition) + "ms")
      } }
    }
  },
  methods: {
    updateScale: function updateScale(currentWidth, maxWidth) {
      this.scale = maxWidth / currentWidth;
    },
    updateNodeWidth: function updateNodeWidth() {
      this.currentWidth = getNodeWidth(this.$el);
      this.maxWidth = getNodeWidth(this.$el.parentElement);
    }
  },
  mounted: function mounted() {
    this.updateNodeWidth();
    this.updateScale(this.currentWidth, this.maxWidth);
  },
  updated: function updated() {
    this.updateNodeWidth();
    this.updateScale(this.currentWidth, this.maxWidth);
  }
};

// install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component("VueResponsiveText", component);
}

// create module definition for Vue.use()
var plugin = {
  install: install
};

// auto-install when vue is found
var GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

export default component;
export { install };
